import { render, staticRenderFns } from "./new-list-header.component.vue?vue&type=template&id=d1cd9262&scoped=true"
import script from "./new-list-header.component.vue?vue&type=script&lang=js"
export * from "./new-list-header.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1cd9262",
  null
  
)

export default component.exports